import { useAtomValue } from "jotai";
import { FunctionalComponent } from "preact";
import { useMemo } from "preact/hooks";

import { EarnAmount, FAQ } from "@/components";
import { Caption, Heading, TextButton } from "@/uikit";

import { earnAmountAtom } from "@/components/EarnAmount";
import {
  EarnOffer,
  EarnOfferData,
  EarnOfferSection,
} from "@/components/EarnOffer";
import { EarnModal } from "@/components/EarnOffer/modal";
import { useAccount } from "@/hooks/useAccount";
import { useNavigation } from "@/hooks/useNavigation";
import { historicalApyAtom } from "@/state/api/blockchainData";
import { useModal } from "@/uikit/Modal";
import { urlSafe } from "@/utils/urls";

import { getOfferDescription, offers } from "./offers";

import "./style.css";

export const getOfferDomain = (offer: EarnOfferData) => {
  return urlSafe(offer.name);
};

export const Earn: FunctionalComponent<{ page: any }> = () => {
  const modalControls = useModal();
  const { subpage, navigate } = useNavigation();
  const account = useAccount();
  const value = useAtomValue(earnAmountAtom);
  const apy = useAtomValue(historicalApyAtom);

  const baseApySection: EarnOfferSection = {
    color: "purple",
    description: getOfferDescription("Tonstakers Staking"),
    value: apy.toNumber(),
  };

  const currentOffer = useMemo(
    () => offers.find((offer) => getOfferDomain(offer) === subpage),
    [subpage],
  );

  return (
    <>
      <div className="calculator gap-vertical">
        <Heading level={1}>Earn More with Tonstakers&nbsp;tsTON</Heading>
        <Caption>
          Put your&nbsp;tsTON into TON&nbsp;products to&nbsp;Earn&nbsp;More
        </Caption>
        <EarnAmount />
        {offers.map((offer, i) => {
          const id = getOfferDomain(offer);
          const isCurrent = id == subpage;

          return (
            <EarnOffer
              i={i}
              isOpen={isCurrent}
              isActive={isCurrent}
              onClick={() => {
                if (!isCurrent) {
                  navigate("earn", id);
                } else {
                  navigate("earn");
                }
              }}
              amount={value}
              icon={offer.icon}
              name={offer.name}
              sections={[baseApySection, ...offer.sections]}
              key={offer.name}
            />
          );
        })}
        {account.connected ? (
          currentOffer ? (
            <TextButton
              onClick={() =>
                modalControls.addLayer(({ controls }) => (
                  <EarnModal offer={currentOffer} controls={controls} />
                ))
              }
            >
              Earn More × {currentOffer.name}
            </TextButton>
          ) : (
            <TextButton disabled={true}>Choose an offer to continue</TextButton>
          )
        ) : (
          <TextButton onClick={account.connect}>
            Connect Wallet to Earn
          </TextButton>
        )}
      </div>
      <FAQ type="earn" />
    </>
  );
};
